export default (htmlStr) => ({
    __html: htmlStr,
});
